import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import NavBar from './components/NavBar';
import Footer from './components/Footer';
import SupportChatWidget from './components/SupportChatWidget';
import Home from './pages/home';
import MenuPage from './pages/menu';
import CombosPage from './pages/combos';
import CartPage from './pages/cart';
import CheckoutPage from './pages/checkout';
import ServicesPage from './pages/services';
import CateringServicesPage from './pages/cateringServices';
import RentalServicesPage from './pages/rentalServices';
import ContactPage from './pages/contact';
import AboutPage from './pages/about';
import OrderStatusPage from './pages/orderStatus';
import AuthPage from './pages/auth';
import ProfilePage from './pages/profile';
import MyOrdersPage from './pages/myOrders';
import NotFoundPage from './pages/notFound';
import { CartProvider } from './context/CartContext';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';

const shouldHideFooter = (pathname) =>
  pathname === '/cart' ||
  pathname === '/profile' ||
  pathname === '/my-orders' ||
  pathname.startsWith('/order-status/');

const shouldShowSupportChat = (pathname) =>
  pathname === '/' ||
  pathname === '/menu' ||
  pathname === '/about' ||
  pathname === '/contact' ||
  pathname === '/profile' ||
  pathname === '/services' ||
  pathname.startsWith('/services/');

function AppLayout() {
  const location = useLocation();

  return (
    <div className="page-vav">
      <NavBar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/menu" element={<MenuPage />} />
          <Route path="/combos" element={<CombosPage />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/account" element={<AuthPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/my-orders" element={<MyOrdersPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/services/catering" element={<CateringServicesPage />} />
          <Route path="/services/rental" element={<RentalServicesPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/order-status/:orderId" element={<OrderStatusPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
      {!shouldHideFooter(location.pathname) && <Footer />}
      {shouldShowSupportChat(location.pathname) && <SupportChatWidget />}
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <AppLayout />
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
